import type { ReactNode } from 'react';
import { Alert } from '@launchpad-ui/components';
import type { AlertProps } from '@launchpad-ui/components';
import { clsx } from 'clsx';

import styles from './PurpleAlert.module.css';

export type PurpleAlertProps = Omit<AlertProps, 'status'> & {
  children: ReactNode;
};

export function PurpleAlert({ children, className, ...props }: PurpleAlertProps) {
  return (
    <Alert status="neutral" {...props} className={clsx(styles.alert, className)}>
      {children}
    </Alert>
  );
}
